export const API_URL = process.env.VUE_APP_API_URL
export const MEDIA_URL = process.env.VUE_APP_MEDIA_URL
export const SITE_PUBLIC_DOMAIN = process.env.VUE_APP_SITE_PUBLIC_DOMAIN